export const SHARE_SITES = {
  GOOGLE: 'Google',
  OUTLOOK: 'Outlook',
  YAHOO: 'Yahoo',
};
